import UtilDateTime from "@/utils/UtilDateTime";

// Status padrão para novos orçamentos: "Em Execução"
export const STATUS_EM_EXECUCAO_ID = "783a5f8a-684f-47f1-a700-a64fb6ab0279";
export const STATUS_EM_EXECUCAO_DESC = "Em Execução";
// Status para quando Job é gerado: "Pedido Colocado"
export const STATUS_PEDIDO_COLOCADO_ID = "18ad60ed-258c-425e-8ecf-3f2afe7d9e05";
export const STATUS_PEDIDO_COLOCADO_DESC = "Pedido Colocado";

// Tipo de venda do orçamento: define a regra de cálculo fiscal dos itens (mesmos valores internos usados no JOB)
export const TIPOS_ORCAMENTO_VENDA = [
  { value: "Consumo", label: "Venda para Consumo/Investimento" },
  { value: "Revenda", label: "Venda para Revendedor" },
  { value: "Recap", label: "Venda Para Recap" }
];

// Descrição do tipo de equipamento que identifica itens de serviço (regra igual ao JOB)
export const TIPO_EQUIPAMENTO_SERVICOS_DESCRICAO = "SERVICOS";

// Tipo de Orçamento: define se a Solicitação é Comercial, Técnica ou as duas juntas.
// Campo obrigatório para salvar (ver salvarOrcamento/validarCamposParaGerarJob) e editável
// sempre que os demais campos de edição estiverem habilitados (ex.: durante uma revisão).
export const TIPOS_DE_ORCAMENTO = [
  { value: "Comercial", label: "Comercial" },
  { value: "Tecnica", label: "Técnica" },
  { value: "ComercialETecnica", label: "Comercial e Técnica" }
];

// ---------------------------------------------------------------------------
// WORKAROUND (a pedido do usuário, ciente do trade-off): o SalesOrder é uma
// "strongEntity" no backend (classe C# com propriedades fixas). Campos novos
// que não existem nessa classe são aceitos pela API sem erro, mas descartados
// silenciosamente na gravação (confirmado em teste ao vivo com hard-reload).
// Isso afeta tipoPropostaOrcamento e as 3 datas do bloco Comercial
// (dataSolicitacaoComercial/dataDesejadaComercial/dataConclusaoComercial), que
// não têm propriedade correspondente no backend ainda. Consertar de verdade
// exige mudança de código no backend (fora do escopo deste front).
//
// Enquanto isso não acontece, esses valores são serializados como um bloco
// JSON escondido dentro do campo "observacao" (Observações), que é um campo
// de texto simples já existente e confirmado persistente. O texto realmente
// digitado pelo usuário nas Observações fica antes do marcador e é exibido
// normalmente na tela; o bloco JSON nunca aparece pro usuário.
// Assim que o backend expuser essas propriedades de verdade, essa camada
// pode ser removida (os campos já são enviados normalmente no payload today,
// então passam a persistir "de graça" assim que o backend reconhecer o nome).
// ---------------------------------------------------------------------------
const MARCADOR_EXTRAS_OBSERVACAO_REGEX = /\n?\[\[SO_EXTRA_DATA:([\s\S]*?)\]\]\s*$/;

export const codificarExtrasSalesOrderEmObservacao = (observacaoTexto = "", extras = {}) => {
  const textoLimpo = String(observacaoTexto ?? "").replace(MARCADOR_EXTRAS_OBSERVACAO_REGEX, "").replace(/\s+$/, "");
  const extrasRelevantes = {
    tipoPropostaOrcamento: extras.tipoPropostaOrcamento || null,
    dataSolicitacaoComercial: extras.dataSolicitacaoComercial || "",
    dataDesejadaComercial: extras.dataDesejadaComercial || "",
    dataConclusaoComercial: extras.dataConclusaoComercial || ""
  };
  const temAlgumValor = Object.values(extrasRelevantes).some((v) => !!v);
  if (!temAlgumValor) return textoLimpo;
  return `${textoLimpo}\n[[SO_EXTRA_DATA:${JSON.stringify(extrasRelevantes)}]]`;
};

export const extrairExtrasSalesOrderDeObservacao = (observacaoBruta = "") => {
  const texto = String(observacaoBruta ?? "");
  const match = texto.match(MARCADOR_EXTRAS_OBSERVACAO_REGEX);
  if (!match) {
    return { observacaoLimpa: texto, extras: {} };
  }
  let extras = {};
  try {
    extras = JSON.parse(match[1]) || {};
  } catch (_) {
    extras = {};
  }
  return {
    observacaoLimpa: texto.replace(MARCADOR_EXTRAS_OBSERVACAO_REGEX, "").replace(/\s+$/, ""),
    extras
  };
};

export const criarFormularioPadrao = () => ({
  id: null,
  code: "",
  // cabeçalho
  contabilizar: false,
  numeroProposta: "",
  origem: "DELTA DUCON",
  revisao: "",
  versionTec: "ORIGINAL",
  ultimaRevisao: "",
  dataCriacao: UtilDateTime.todayISO(),
  dateGenerate: UtilDateTime.todayISO(),
  tipoFaturamento: null,
  tipoPropostaOrcamento: null,
  tipoOrcamentoVenda: null,
  tipoDeEquipamento: null,
  tipoDeEquipamentoSigla: "",
  tipoDeEquipamentoDescricao: "",
  nivel: "",
  job: null,
  jobNome: "",
  // legado / compatibilidade
  numeroSolicitacao: "",
  dataSolicitacao: UtilDateTime.todayISO(),
  status: STATUS_EM_EXECUCAO_ID,
  statusDescription: STATUS_EM_EXECUCAO_DESC,
  // cliente
  cliente: null,
  clienteNome: "",
  clienteCnpj: "",
  referenciaCliente: "",
  cliente_referencia: "",
  vendedor: null,
  vendedorNome: "",
  orcamentista: null,
  orcamentistaNome: "",
  contato: null,
  contatoNome: "",
  contatoTecnico: null,
  contatoTecnicoNome: "",
  contatoTecnicoTelefone: "",
  contatoTecnicoCelular: "",
  contatoTecnicoEmail: "",
  email: "",
  telefone: "",
  contatoComercialTelefone: "",
  contatoComercialCelular: "",
  contatoComercialEmail: "",
  // financeiro
  descricao: "",
  projetoDescricao: "",
  observacao: "",
  prazoResposta: "",
  valorEstimado: "0,00",
  valorDisponivel: "0,00",
  ki: "0,000",
  kidoCusto: "0,00",
  porcentagemPIS: "0,00",
  porcentagemCOFINS: "0,00",
  porcentagemISS: "0,00",
  porcentagemIIS: "0,00",
  porcentagemICMSVenda: "0,00",
  pocentagemIPIVenda: "0,00",
  porcentagemIPI: "0,00",
  precoVenda_sIPI_cICMS: "0,00",
  precoVenda_cIPI_cICMS: "0,00",
  precoVenda_sIPI_sICMS: "0,00",
  precoVenda_cISS: "0,00",
  kv: "0,000",
  valorICMS: "0,00",
  valorIPI: "0,00",
  // agregados fiscais dos itens (soma), aplicaveis conforme o tipo de equipamento dos itens
  precoTotalLiquido: "0,00",
  baseCalculoICMS: "0,00",
  baseCalculoPIS: "0,00",
  valorPIS: "0,00",
  baseCalculoCOFINS: "0,00",
  valorCOFINS: "0,00",
  baseCalculoISS: "0,00",
  valorISS: "0,00",
  baseCalculoIRRF: "0,00",
  valorIRRF: "0,00",
  baseCalculoCSLL: "0,00",
  valorCSLL: "0,00",
  baseCalculoINSS: "0,00",
  valorINSS: "0,00",
  // proposta tecnica
  projeto: "",
  dataDesejada: "",
  dataDespacho: "",
  dataConclusao: "",
  // proposta comercial (datas) — mesma regra da abertura técnica: data solicitação já vem com o dia atual
  dataSolicitacaoComercial: UtilDateTime.todayISO(),
  dataDesejadaComercial: "",
  dataConclusaoComercial: "",
  // sub-entidades (gerenciados localmente no pai)
  itens: []
});

export const criarItemPadrao = () => ({
  tipoDeEquipamento: "",
  tipoDeEquipamentoDescricao: "",
  tipoDeServico: "",
  tipoDeServicoDescricao: "",
  // NCM (Nomenclatura Comum do Mercosul): só se aplica a item de Produto (Serviço não tem NCM,
  // usa NBS na nota fiscal de serviço, fora do escopo deste campo).
  ncm: "",
  ncmDescricao: "",
  descricao: "",
  description: "",
  quantidade: 1,
  qty: 1,
  unidade: "",
  dtPrev: "",
  observacao: "",
  obs: "",
  valorDisponivel: "0,00",
  valorDisponivelTotal: "0,00",
  porcentagemPIS: "0,00",
  porcentagemCOFINS: "0,00",
  ki: "0,000",
  kidoCusto: "0,00",
  porcentagemISS: "0,00",
  porcentagemIIS: "0,00",
  porcentagemICMSVenda: "0,00",
  pocentagemIPIVenda: "0,00",
  porcentagemIPI: "0,00",
  kv: "0,000",
  precoVenda_sIPI_cICMS: "0,00",
  precoVenda_cIPI_cICMS: "0,00",
  precoVenda_sIPI_sICMS: "0,00",
  precoVenda_cISS: "0,00",
  valorICMS: "0,00",
  valorIPI: "0,00",
  vlrTotal: "0,00",
  valorTotal: "0,00",
  _mirror_valor_sIPI_cICMS: "0,00",
  // novos campos fiscais (venda) do item
  precoTotalLiquido: "0,00",
  // Ao abrir a tela (antes de o usuário escolher o Tipo de Equipamento), toda base de cálculo
  // começa em 0%. Só vira 100% quando o usuário seleciona um tipo, em
  // aoSelecionarTipoDeEquipamentoItem() (ModalSolicitacaoDeOrcamento.vue), para o(s) campo(s)
  // aplicável(is) àquele tipo.
  porcentagemBaseCalculoICMS: "0,00",
  baseCalculoICMS: "0,00",
  porcentagemBaseCalculoISS: "0,00",
  baseCalculoISS: "0,00",
  porcentagemBaseCalculoIRRF: "0,00",
  baseCalculoIRRF: "0,00",
  porcentagemIRRF: "0,00",
  valorIRRF: "0,00",
  porcentagemBaseCalculoPIS: "0,00",
  baseCalculoPIS: "0,00",
  valorPIS: "0,00",
  porcentagemBaseCalculoCOFINS: "0,00",
  baseCalculoCOFINS: "0,00",
  valorCOFINS: "0,00",
  porcentagemBaseCalculoCSLL: "0,00",
  baseCalculoCSLL: "0,00",
  porcentagemCSLL: "0,00",
  valorCSLL: "0,00",
  porcentagemBaseCalculoINSS: "0,00",
  baseCalculoINSS: "0,00",
  porcentagemINSS: "0,00",
  valorINSS: "0,00"
});

export const normalizarItem = (item = {}) => ({
  // BUGFIX (a pedido do usuário): o id do próprio registro SalesOrderItem nunca era preservado aqui —
  // normalizarItem() é chamado tanto ao carregar os itens salvos (abrirOrcamentoPorModo) quanto a cada
  // adicionar/editar item (adicionarItem/atualizarItem/confirmarNovoItem), então o id se perdia já na
  // primeira normalização. Resultado grave: sanitizarItemPayloadSalesOrder() nunca encontrava um id pra
  // incluir no payload (obterIdRegistro(item) sempre null), então TODO "GRAVAR" de uma Solicitação já
  // salva criava um SalesOrderItem NOVO no banco em vez de atualizar o existente (confirmado via GET
  // direto na API: updateAt continuava null mesmo depois de editar e salvar um item já existente) —
  // e é por isso que campos novos como o NCM (ou qualquer edição num item já salvo) nunca "grudavam":
  // a edição ia para um registro órfão diferente do que a Solicitação continuava referenciando.
  id: item.id || item._id || "",
  tipoDeEquipamento:
    (typeof item.tipoDeEquipamento === "object" ? item.tipoDeEquipamento?.id : item.tipoDeEquipamento) || "",
  tipoDeEquipamentoDescricao:
    item.tipoDeEquipamentoDescricao ||
    item.tipoDeEquipamento?.descricao ||
    item.tipoDeEquipamento?.description ||
    "",
  tipoDeServico:
    (typeof item.tipoDeServico === "object" ? item.tipoDeServico?.id : item.tipoDeServico) || "",
  tipoDeServicoDescricao:
    item.tipoDeServicoDescricao ||
    item.tipoDeServico?.servicoDescricao ||
    item.tipoDeServico?.descricao ||
    item.tipoDeServico?.description ||
    "",
  ncm: (typeof item.ncm === "object" ? item.ncm?.id : item.ncm) || "",
  ncmDescricao:
    item.ncmDescricao ||
    item.ncm?.descricaoCompleta ||
    item.ncm?.descricao ||
    item.ncm?.description ||
    "",
  descricao: item.descricao || item.description || "",
  description: item.description || item.descricao || "",
  quantidade: item.quantidade !== undefined ? item.quantidade : (item.qty !== undefined ? item.qty : 1),
  qty: item.qty !== undefined ? item.qty : (item.quantidade !== undefined ? item.quantidade : 1),
  unidade: item.unidade || "",
  dtPrev: item.dtPrev || "",
  observacao: item.observacao || item.obs || "",
  obs: item.obs || item.observacao || "",
  valorDisponivel: item.valorDisponivel !== undefined ? item.valorDisponivel : "0,00",
  valorDisponivelTotal: item.valorDisponivelTotal !== undefined
    ? item.valorDisponivelTotal
    : formatarNumeroInput(parseNumero(item.quantidade ?? item.qty ?? 1) * parseNumero(item.valorDisponivel ?? 0)),
  porcentagemPIS: item.porcentagemPIS !== undefined ? item.porcentagemPIS : "0,00",
  porcentagemCOFINS: item.porcentagemCOFINS !== undefined ? item.porcentagemCOFINS : "0,00",
  ki: item.ki !== undefined ? item.ki : "0,000",
  kidoCusto: item.kidoCusto !== undefined ? item.kidoCusto : "0,00",
  porcentagemISS: item.porcentagemISS !== undefined ? item.porcentagemISS : (item.porcentagemIIS !== undefined ? item.porcentagemIIS : "0,00"),
  porcentagemIIS: item.porcentagemIIS !== undefined ? item.porcentagemIIS : (item.porcentagemISS !== undefined ? item.porcentagemISS : "0,00"),
  porcentagemICMSVenda: item.porcentagemICMSVenda !== undefined ? item.porcentagemICMSVenda : "0,00",
  pocentagemIPIVenda: item.pocentagemIPIVenda !== undefined ? item.pocentagemIPIVenda : (item.porcentagemIPI !== undefined ? item.porcentagemIPI : "0,00"),
  porcentagemIPI: item.porcentagemIPI !== undefined ? item.porcentagemIPI : (item.pocentagemIPIVenda !== undefined ? item.pocentagemIPIVenda : "0,00"),
  kv: item.kv !== undefined ? item.kv : "0,000",
  precoVenda_sIPI_cICMS: item.precoVenda_sIPI_cICMS !== undefined ? item.precoVenda_sIPI_cICMS : "0,00",
  precoVenda_cIPI_cICMS: item.precoVenda_cIPI_cICMS !== undefined ? item.precoVenda_cIPI_cICMS : "0,00",
  precoVenda_sIPI_sICMS: item.precoVenda_sIPI_sICMS !== undefined ? item.precoVenda_sIPI_sICMS : "0,00",
  precoVenda_cISS: item.precoVenda_cISS !== undefined ? item.precoVenda_cISS : "0,00",
  valorICMS: item.valorICMS !== undefined ? item.valorICMS : "0,00",
  valorIPI: item.valorIPI !== undefined ? item.valorIPI : "0,00",
  vlrTotal: item.vlrTotal !== undefined ? item.vlrTotal : "0,00",
  valorTotal: item.valorTotal !== undefined ? item.valorTotal : "0,00",
  _mirror_valor_sIPI_cICMS: item._mirror_valor_sIPI_cICMS !== undefined ? item._mirror_valor_sIPI_cICMS : "0,00",
  // novos campos fiscais (venda) do item
  precoTotalLiquido: item.precoTotalLiquido !== undefined ? item.precoTotalLiquido : "0,00",
  porcentagemBaseCalculoICMS: item.porcentagemBaseCalculoICMS !== undefined ? item.porcentagemBaseCalculoICMS : "0,00",
  baseCalculoICMS: item.baseCalculoICMS !== undefined ? item.baseCalculoICMS : "0,00",
  porcentagemBaseCalculoISS: item.porcentagemBaseCalculoISS !== undefined ? item.porcentagemBaseCalculoISS : "0,00",
  baseCalculoISS: item.baseCalculoISS !== undefined ? item.baseCalculoISS : "0,00",
  // BUGFIX: campo valorISS estava ausente desta lista, então normalizarItem() descartava
  // silenciosamente o ISS já calculado do item toda vez que um item era adicionado/editado
  // (adicionarItem/atualizarItem chamam normalizarItem em todo insert/update). Resultado:
  // o item perdia seu próprio valorISS antes de ser guardado em formulario.itens, e o
  // somatório do cabeçalho (calcularCamposDeItens) somava undefined -> 0,00.
  // BUGFIX #2 (a pedido do usuário — investigação do bug de NCM): o schema do SalesOrderItem no
  // backend nunca teve um campo "valorISS" — o Entity genérico rejeita com 400 qualquer update que
  // inclua um campo fora do schema, então valorISS foi removido do payload de save
  // (sanitizarItemPayloadSalesOrder). Por isso, ao carregar um item salvo, ele nunca vem com
  // valorISS do backend — recalcula aqui a partir de baseCalculoISS x porcentagemISS, mesma lógica
  // usada no cálculo original do item (ver calcularImpostosVendaItem/novoItemCalculado).
  valorISS: item.valorISS !== undefined
    ? item.valorISS
    : formatarNumeroInput(parseNumero(item.baseCalculoISS ?? 0) * parseNumero(item.porcentagemISS ?? 0) / 100),
  porcentagemBaseCalculoIRRF: item.porcentagemBaseCalculoIRRF !== undefined ? item.porcentagemBaseCalculoIRRF : "0,00",
  baseCalculoIRRF: item.baseCalculoIRRF !== undefined ? item.baseCalculoIRRF : "0,00",
  porcentagemIRRF: item.porcentagemIRRF !== undefined ? item.porcentagemIRRF : "0,00",
  valorIRRF: item.valorIRRF !== undefined ? item.valorIRRF : "0,00",
  porcentagemBaseCalculoPIS: item.porcentagemBaseCalculoPIS !== undefined ? item.porcentagemBaseCalculoPIS : "0,00",
  baseCalculoPIS: item.baseCalculoPIS !== undefined ? item.baseCalculoPIS : "0,00",
  valorPIS: item.valorPIS !== undefined ? item.valorPIS : "0,00",
  porcentagemBaseCalculoCOFINS: item.porcentagemBaseCalculoCOFINS !== undefined ? item.porcentagemBaseCalculoCOFINS : "0,00",
  baseCalculoCOFINS: item.baseCalculoCOFINS !== undefined ? item.baseCalculoCOFINS : "0,00",
  valorCOFINS: item.valorCOFINS !== undefined ? item.valorCOFINS : "0,00",
  porcentagemBaseCalculoCSLL: item.porcentagemBaseCalculoCSLL !== undefined ? item.porcentagemBaseCalculoCSLL : "0,00",
  baseCalculoCSLL: item.baseCalculoCSLL !== undefined ? item.baseCalculoCSLL : "0,00",
  porcentagemCSLL: item.porcentagemCSLL !== undefined ? item.porcentagemCSLL : "0,00",
  valorCSLL: item.valorCSLL !== undefined ? item.valorCSLL : "0,00",
  porcentagemBaseCalculoINSS: item.porcentagemBaseCalculoINSS !== undefined ? item.porcentagemBaseCalculoINSS : "0,00",
  baseCalculoINSS: item.baseCalculoINSS !== undefined ? item.baseCalculoINSS : "0,00",
  porcentagemINSS: item.porcentagemINSS !== undefined ? item.porcentagemINSS : "0,00",
  valorINSS: item.valorINSS !== undefined ? item.valorINSS : "0,00"
});

export const calcularValorTotalItem = (item = {}) => {
  const quantidade = parseNumero(item.quantidade);
  const preco = parseNumero(item.precoVenda_sIPI_cICMS);
  return Number((quantidade * preco).toFixed(2));
};

export const calcularValorDisponivelTotalItem = (item = {}) => {
  const quantidade = parseNumero(item.quantidade ?? item.qty);
  const valorDisponivel = parseNumero(item.valorDisponivel);
  return Number((quantidade * valorDisponivel).toFixed(2));
};

export const calcularCamposDeItens = (itens = []) => {
  // BUGFIX (a pedido do usuário): ao remover o último item da solicitação, esta função retornava null
  // (array vazio), e aplicarCamposDeItens() (SolicitacaoDeOrcamentoView.vue) interpretava isso como "nada
  // a atualizar" e retornava sem tocar em formulario.*, então os totais do orçamento (ICMS, IPI, PIS,
  // COFINS, Preço Total Líquido, impostos de serviço etc.) continuavam mostrando os valores do(s) item(ns)
  // já excluído(s). Agora só é considerado inválido o caso de itens não ser um array; um array vazio segue
  // pelo reduce normalmente e soma zero em cada campo, zerando os totais na tela.
  if (!Array.isArray(itens)) return null;

  const soma = itens.reduce((acc, item) => {
    const valorTotalItem = calcularValorTotalItem(item);
    acc.precoVenda_sIPI_cICMS += valorTotalItem;
    
    // Calcula impostos como percentual sobre o valor total do item (já considerando quantidade)
    const porcentagemICMS = parseNumero(item.porcentagemICMSVenda);
    const porcentagemIPI = parseNumero(item.porcentagemIPI);
    
    acc.valorICMS += (valorTotalItem * porcentagemICMS) / 100;
    acc.valorIPI += (valorTotalItem * porcentagemIPI) / 100;
    
    // Custo disponível total sempre é derivado de Qtd x Custo Unitário do item.
    acc.valorDisponivel += calcularValorDisponivelTotalItem(item);
    return acc;
  }, {
    precoVenda_sIPI_cICMS: 0, valorICMS: 0, valorIPI: 0, valorDisponivel: 0,
    precoTotalLiquido: 0, baseCalculoICMS: 0,
    baseCalculoPIS: 0, valorPIS: 0, baseCalculoCOFINS: 0, valorCOFINS: 0,
    baseCalculoISS: 0, valorISS: 0, baseCalculoIRRF: 0, valorIRRF: 0,
    baseCalculoCSLL: 0, valorCSLL: 0, baseCalculoINSS: 0, valorINSS: 0
  });

  return {
    precoVenda_sIPI_cICMS: formatarNumeroInput(soma.precoVenda_sIPI_cICMS),
    precoVenda_cIPI_cICMS: formatarNumeroInput(soma.precoVenda_sIPI_cICMS + soma.valorIPI),
    valorICMS: formatarNumeroInput(soma.valorICMS),
    valorIPI: formatarNumeroInput(soma.valorIPI),
    valorDisponivel: formatarNumeroInput(soma.valorDisponivel),
    precoTotalLiquido: formatarNumeroInput(soma.precoTotalLiquido),
    baseCalculoICMS: formatarNumeroInput(soma.baseCalculoICMS),
    baseCalculoPIS: formatarNumeroInput(soma.baseCalculoPIS),
    valorPIS: formatarNumeroInput(soma.valorPIS),
    baseCalculoCOFINS: formatarNumeroInput(soma.baseCalculoCOFINS),
    valorCOFINS: formatarNumeroInput(soma.valorCOFINS),
    baseCalculoISS: formatarNumeroInput(soma.baseCalculoISS),
    valorISS: formatarNumeroInput(soma.valorISS),
    baseCalculoIRRF: formatarNumeroInput(soma.baseCalculoIRRF),
    valorIRRF: formatarNumeroInput(soma.valorIRRF),
    baseCalculoCSLL: formatarNumeroInput(soma.baseCalculoCSLL),
    valorCSLL: formatarNumeroInput(soma.valorCSLL),
    baseCalculoINSS: formatarNumeroInput(soma.baseCalculoINSS),
    valorINSS: formatarNumeroInput(soma.valorINSS)
  };
};

export const parseNumero = (valor) => {
  if (typeof valor === "number") return Number.isFinite(valor) ? valor : 0;
  if (valor === null || valor === undefined || valor === "") return 0;
  const texto = String(valor).trim();
  const textoNormalizado = texto
    .replace(/\s/g, "")
    .replace(/(\d)\.(?=\d{3}(\D|$))/g, "$1")
    .replace(",", ".");
  const numero = Number(textoNormalizado);
  return Number.isFinite(numero) ? numero : 0;
};

export const formatarNumeroInput = (valor, casas = 2) => {
  const numero = parseNumero(valor);
  return Number(numero).toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas
  });
};

export const formatarKv = (valor) => {
  return parseNumero(valor).toLocaleString("pt-BR", {
    minimumFractionDigits: 3,
    maximumFractionDigits: 3
  });
};

export const recalcularCamposPreco = (formulario = {}) => {
  const valorDisponivel = parseNumero(formulario.valorDisponivel);
  const ki = parseNumero(formulario.ki);
  const porcentagemICMSVenda = parseNumero(formulario.porcentagemICMSVenda);
  const precoVendaComIcms = parseNumero(formulario.precoVenda_sIPI_cICMS);

  let precoVendaSemIcms = precoVendaComIcms;
  if (porcentagemICMSVenda > 0) {
    precoVendaSemIcms = precoVendaComIcms - ((porcentagemICMSVenda / 100) * precoVendaComIcms);
  }

  // BUGFIX (a pedido do usuário): para Serviço, o preço de venda digitado pelo usuário JÁ
  // contém o ISS embutido - a mesma lógica do ICMS "por dentro" usada no Produto (ver
  // calcularImpostosVendaServico, que já SUBTRAI o ISS do preço informado para achar o
  // líquido). Este campo somava o ISS por cima do preço, como se o valor digitado fosse
  // líquido de ISS - resultando em um "preço com ISS" inflado (ISS contado em dobro). Como
  // o preço já inclui o ISS, o valor "com ISS" é o próprio preço informado (sem ICMS, se
  // aplicável), sem soma adicional.
  const precoVendaComIss = precoVendaSemIcms;

  let kiDoCusto = 0;
  if (precoVendaComIcms !== 0 && ki !== 0) {
    kiDoCusto = precoVendaComIcms * ki;
  }

  const kv = kiDoCusto !== 0 ? (valorDisponivel / kiDoCusto) : 0;
  const valorIPI = parseNumero(formulario.valorIPI);

  return {
    precoVenda_cIPI_cICMS: formatarNumeroInput(Number((precoVendaComIcms + valorIPI).toFixed(2))),
    precoVenda_sIPI_sICMS: formatarNumeroInput(Number(precoVendaSemIcms.toFixed(2))),
    precoVenda_cISS: formatarNumeroInput(Number(precoVendaComIss.toFixed(2))),
    kidoCusto: formatarNumeroInput(Number(kiDoCusto.toFixed(2))),
    kv: formatarKv(kv)
  };
};

export const recalcularCamposComerciaisItem = (item = {}) => {
  const quantidade = parseNumero(item.quantidade ?? item.qty);
  const valorDisponivel = parseNumero(item.valorDisponivel);
  const ki = parseNumero(item.ki);
  const porcentagemICMSVenda = parseNumero(item.porcentagemICMSVenda);
  const porcentagemIPI = parseNumero(item.pocentagemIPIVenda || item.porcentagemIPI);
  const precoVendaComIcms = parseNumero(item.precoVenda_sIPI_cICMS);

  const valorICMS = Number(((porcentagemICMSVenda / 100) * precoVendaComIcms).toFixed(2));
  const valorIPI = Number(((porcentagemIPI / 100) * precoVendaComIcms).toFixed(2));
  const precoVendaComIpi = Number((precoVendaComIcms + valorIPI).toFixed(2));

  let precoVendaSemIcms = precoVendaComIcms;
  if (porcentagemICMSVenda > 0) {
    precoVendaSemIcms = precoVendaComIcms - valorICMS;
  }

  // BUGFIX (a pedido do usuário - mesma correção aplicada em recalcularCamposPreco): para
  // Serviço, o preço de venda digitado pelo usuário JÁ contém o ISS embutido - a mesma
  // lógica do ICMS "por dentro" usada no Produto (ver calcularImpostosVendaServico, que já
  // SUBTRAI o ISS do preço informado para achar o líquido). Este campo somava o ISS por
  // cima do preço, como se o valor digitado fosse líquido de ISS - resultando em um "preço
  // com ISS" inflado (ISS contado em dobro). Como o preço já inclui o ISS, o valor "com
  // ISS" é o próprio preço informado (sem ICMS, se aplicável), sem soma adicional.
  const precoVendaComIss = precoVendaSemIcms;

  let kiDoCusto = 0;
  if (precoVendaComIcms !== 0 && ki !== 0) {
    kiDoCusto = precoVendaComIcms * ki;
  }

  const kv = kiDoCusto !== 0 ? (valorDisponivel / kiDoCusto) : 0;
  const vlrTotal = Number((quantidade * precoVendaComIcms).toFixed(2));
  const valorDisponivelTotal = Number((quantidade * valorDisponivel).toFixed(2));

  return {
    quantidade: quantidade || 0,
    qty: quantidade || 0,
    valorICMS: formatarNumeroInput(valorICMS),
    valorIPI: formatarNumeroInput(valorIPI),
    precoVenda_cIPI_cICMS: formatarNumeroInput(precoVendaComIpi),
    precoVenda_sIPI_sICMS: formatarNumeroInput(Number(precoVendaSemIcms.toFixed(2))),
    precoVenda_cISS: formatarNumeroInput(Number(precoVendaComIss.toFixed(2))),
    kidoCusto: formatarNumeroInput(Number(kiDoCusto.toFixed(2))),
    kv: formatarKv(kv),
    vlrTotal: formatarNumeroInput(vlrTotal),
    valorTotal: formatarNumeroInput(vlrTotal),
    valorDisponivelTotal: formatarNumeroInput(valorDisponivelTotal),
    _mirror_valor_sIPI_cICMS: formatarNumeroInput(valorDisponivel)
  };
};

// Verifica se o item é do tipo de equipamento SERVIÇOS (mesma regra usada no JOB)
export const itemEhServico = (item = {}) => {
  const descricao = String(item.tipoDeEquipamentoDescricao || "").trim().toUpperCase();
  return descricao === TIPO_EQUIPAMENTO_SERVICOS_DESCRICAO;
};

// Calcula ICMS/IPI/PIS/COFINS de itens de produto conforme o tipo de venda do orçamento (regras portadas do JOB)
const calcularImpostosVendaProduto = (item = {}, tipoOrcamentoVenda) => {
  const precoUnitarioComIcms = parseNumero(item.precoVenda_sIPI_cICMS);
  // BUGFIX (a pedido do usuário): a Base de Cálculo do ICMS (e toda a cadeia de impostos do produto
  // que parte dela: IPI, ICMS, Preço Total Líquido) usava só o preço de venda UNITÁRIO, ignorando a
  // quantidade. Agora usa o Preço de Venda TOTAL do item (quantidade x preço de venda unitário) — o
  // mesmo valor já calculado em "Preço de Venda Total Com ICMS e Sem IPI" (vlrTotal/valorTotal).
  const quantidade = parseNumero(item.quantidade ?? item.qty) || 1;
  const precoVendaTotalComIcms = (item.vlrTotal !== undefined || item.valorTotal !== undefined)
    ? parseNumero(item.vlrTotal ?? item.valorTotal)
    : Number((precoUnitarioComIcms * quantidade).toFixed(2));
  const porcentagemIPI = parseNumero(item.pocentagemIPIVenda ?? item.porcentagemIPI);
  const porcentagemICMS = parseNumero(item.porcentagemICMSVenda);
  // BUGFIX: o valor padrão do campo é a string "0,00" (truthy em JS), então o antigo
  // `item.porcentagemBaseCalculoICMS || 100` nunca caía no fallback. Agora comparamos o
  // valor já convertido para número: só assume 100% quando o campo estiver realmente
  // zerado/vazio, preservando qualquer valor > 0 informado manualmente pelo usuário.
  const porcentagemBaseCalculoICMSInformada = parseNumero(item.porcentagemBaseCalculoICMS);
  const porcentagemBaseCalculoICMS = porcentagemBaseCalculoICMSInformada > 0
    ? porcentagemBaseCalculoICMSInformada
    : 100;

  const valorIPI = Number(((porcentagemIPI / 100) * precoVendaTotalComIcms).toFixed(2));

  // Consumo/Investimento e Recap consideram o IPI na base do ICMS; Revenda não considera.
  const baseICMSBruta = tipoOrcamentoVenda === "Revenda"
    ? precoVendaTotalComIcms
    : precoVendaTotalComIcms + valorIPI;

  const baseCalculoICMS = Number(((porcentagemBaseCalculoICMS / 100) * baseICMSBruta).toFixed(2));
  const valorICMS = Number(((porcentagemICMS / 100) * baseCalculoICMS).toFixed(2));
  const precoTotalLiquido = Number((precoVendaTotalComIcms - valorICMS).toFixed(2));

  // Recap: PIS/COFINS são isentos, sempre zero e bloqueados na tela.
  const recapIsento = tipoOrcamentoVenda === "Recap";
  const aplicaPadraoProduto = ["Consumo", "Revenda"].includes(tipoOrcamentoVenda);
  const porcentagemPIS = recapIsento
    ? 0
    : (aplicaPadraoProduto && parseNumero(item.porcentagemPIS) === 0
      ? 1.65
      : parseNumero(item.porcentagemPIS));
  const porcentagemCOFINS = recapIsento
    ? 0
    : (aplicaPadraoProduto && parseNumero(item.porcentagemCOFINS) === 0
      ? 7.6
      : parseNumero(item.porcentagemCOFINS));
  const baseCalculoPIS = recapIsento ? 0 : Number(((100 / 100) * precoTotalLiquido).toFixed(2));
  const baseCalculoCOFINS = recapIsento ? 0 : Number(((100 / 100) * precoTotalLiquido).toFixed(2));
  const valorPIS = recapIsento ? 0 : Number(((porcentagemPIS / 100) * baseCalculoPIS).toFixed(2));
  const valorCOFINS = recapIsento ? 0 : Number(((porcentagemCOFINS / 100) * baseCalculoCOFINS).toFixed(2));

  return {
    valorIPI: formatarNumeroInput(valorIPI),
    baseCalculoICMS: formatarNumeroInput(baseCalculoICMS),
    valorICMS: formatarNumeroInput(valorICMS),
    precoTotalLiquido: formatarNumeroInput(precoTotalLiquido),
    porcentagemPIS: formatarNumeroInput(porcentagemPIS),
    porcentagemCOFINS: formatarNumeroInput(porcentagemCOFINS),
    baseCalculoPIS: formatarNumeroInput(baseCalculoPIS),
    valorPIS: formatarNumeroInput(valorPIS),
    baseCalculoCOFINS: formatarNumeroInput(baseCalculoCOFINS),
    valorCOFINS: formatarNumeroInput(valorCOFINS),
    // Impostos de serviço não se aplicam a produto.
    porcentagemBaseCalculoISS: "0,00",
    baseCalculoISS: "0,00",
    porcentagemISS: "0,00",
    valorISS: "0,00",
    porcentagemBaseCalculoIRRF: "0,00",
    baseCalculoIRRF: "0,00",
    porcentagemIRRF: "0,00",
    valorIRRF: "0,00",
    porcentagemBaseCalculoCSLL: "0,00",
    baseCalculoCSLL: "0,00",
    porcentagemCSLL: "0,00",
    valorCSLL: "0,00",
    porcentagemBaseCalculoINSS: "0,00",
    baseCalculoINSS: "0,00",
    porcentagemINSS: "0,00",
    valorINSS: "0,00"
  };
};

// Calcula os impostos de itens do tipo SERVIÇOS, independente do tipo de venda do orçamento
const calcularImpostosVendaServico = (item = {}) => {
  const precoUnitario = parseNumero(item.precoVenda_sIPI_cICMS);
  // BUGFIX (a pedido do usuário — mesma regra já aplicada ao ICMS de Produto): as bases de cálculo de
  // Serviço (ISS/IRRF/PIS/COFINS/CSLL/INSS) usavam só o preço de venda UNITÁRIO, ignorando a
  // quantidade. Agora usam o Preço de Venda TOTAL do item (quantidade x preço de venda unitário) — o
  // mesmo valor já calculado em "Preço de Venda Total" (vlrTotal/valorTotal).
  const quantidade = parseNumero(item.quantidade ?? item.qty) || 1;
  const precoVendaTotal = (item.vlrTotal !== undefined || item.valorTotal !== undefined)
    ? parseNumero(item.vlrTotal ?? item.valorTotal)
    : Number((precoUnitario * quantidade).toFixed(2));

  const calcularBaseEValor = (porcentagemBaseCampo, porcentagemCampo) => {
    const porcentagemBase = parseNumero(item[porcentagemBaseCampo]);
    const porcentagem = parseNumero(item[porcentagemCampo]);
    const base = Number(((porcentagemBase / 100) * precoVendaTotal).toFixed(2));
    const valor = Number(((porcentagem / 100) * base).toFixed(2));
    return { base, valor };
  };

  const iss = calcularBaseEValor("porcentagemBaseCalculoISS", "porcentagemISS");
  const irrf = calcularBaseEValor("porcentagemBaseCalculoIRRF", "porcentagemIRRF");
  const pis = calcularBaseEValor("porcentagemBaseCalculoPIS", "porcentagemPIS");
  const cofins = calcularBaseEValor("porcentagemBaseCalculoCOFINS", "porcentagemCOFINS");
  const csll = calcularBaseEValor("porcentagemBaseCalculoCSLL", "porcentagemCSLL");
  const inss = calcularBaseEValor("porcentagemBaseCalculoINSS", "porcentagemINSS");

  const precoTotalLiquido = Number((precoVendaTotal - iss.valor - irrf.valor - pis.valor - cofins.valor - csll.valor - inss.valor).toFixed(2));

  return {
    // Serviço não gera ICMS/IPI.
    valorIPI: "0,00",
    porcentagemBaseCalculoICMS: "0,00",
    baseCalculoICMS: "0,00",
    valorICMS: "0,00",
    precoTotalLiquido: formatarNumeroInput(precoTotalLiquido),
    baseCalculoISS: formatarNumeroInput(iss.base),
    valorISS: formatarNumeroInput(iss.valor),
    baseCalculoIRRF: formatarNumeroInput(irrf.base),
    valorIRRF: formatarNumeroInput(irrf.valor),
    baseCalculoPIS: formatarNumeroInput(pis.base),
    valorPIS: formatarNumeroInput(pis.valor),
    baseCalculoCOFINS: formatarNumeroInput(cofins.base),
    valorCOFINS: formatarNumeroInput(cofins.valor),
    baseCalculoCSLL: formatarNumeroInput(csll.base),
    valorCSLL: formatarNumeroInput(csll.valor),
    baseCalculoINSS: formatarNumeroInput(inss.base),
    valorINSS: formatarNumeroInput(inss.valor)
  };
};

// Dispara o cálculo fiscal correto do item: serviço ignora o tipo de venda, produto segue Consumo/Revenda/Recap
export const calcularImpostosVendaItem = (item = {}, tipoOrcamentoVenda = null) => {
  if (itemEhServico(item)) {
    return calcularImpostosVendaServico(item);
  }

  return calcularImpostosVendaProduto(item, tipoOrcamentoVenda);
};

export const normalizaItemSalesOrder = (item = {}, statusDescricaoPorId = {}) => {
  const referenciaClienteValor = String(item.cliente_referencia ?? item.referenciaCliente ?? "").trim();
  const statusId = typeof item.status === "object" ? item.status?.id : item.status;
  const statusDescription =
    item.statusDescription ||
    item.status?.description ||
    statusDescricaoPorId[statusId] ||
    "Sem status";

  const clienteId =
    typeof item.cliente === "object"
      ? item.cliente?.id
      : item.cliente || item.clienteID || null;

  const contatoId =
    (typeof item.contatoComercial === "object"
      ? item.contatoComercial?.id
      : item.contatoComercial) ||
    (typeof item.contato === "object"
      ? item.contato?.id
      : item.contato) ||
    null;

  const contatoTecnicoId =
    typeof item.contatoTecnico === "object"
      ? item.contatoTecnico?.id
      : item.contatoTecnico || null;

  const nivelNormalizado =
    (typeof item.nivel === "object" ? item.nivel?.numero : item.nivel) ??
    (typeof item.nivelProposta === "object" ? item.nivelProposta?.numero : item.nivelProposta) ??
    "";

  const valorDisponivel = item.valorDisponivel ?? item.revisoes?.valorDisponivel ?? 0;
  const ki = item.ki ?? item.revisoes?.ki ?? 0;
  const kidoCusto = item.kidoCusto ?? item.revisoes?.kidoCusto ?? 0;
  const porcentagemICMSVenda = item.porcentagemICMSVenda ?? item.revisoes?.porcentagemICMSVenda ?? "0";
  const precoVenda_sIPI_cICMS =
    item.precoVenda_sIPI_cICMS ??
    item.revisoes?.precoVenda_sIPI_cICMS ??
    item._mirror_valor_sIPI_cICMS ??
    0;
  const precoVenda_sIPI_sICMS = item.precoVenda_sIPI_sICMS ?? item.revisoes?.precoVenda_sIPI_sICMS ?? 0;
  const kv = item.kv ?? item.revisoes?.kv ?? "0,000";
  const sigla =
    item._mirror_tipo ||
    (typeof item.sigla === "object"
      ? item.sigla?.descricao || item.sigla?.description || item.sigla?.nome || item.sigla?.name || item.sigla?.codigo
      : item.sigla) ||
    (typeof item.origem === "object"
      ? item.origem?.descricao || item.origem?.description || item.origem?.nome || item.origem?.name || item.origem?.codigo
      : item.origem) ||
    (typeof item._mirror_tipoDeEquipamento === "object"
      ? item._mirror_tipoDeEquipamento?.descricao ||
        item._mirror_tipoDeEquipamento?.description ||
        item._mirror_tipoDeEquipamento?.nome ||
        item._mirror_tipoDeEquipamento?.name ||
        item._mirror_tipoDeEquipamento?.codigo
      : item._mirror_tipoDeEquipamento) ||
    "";

  return {
    ...item,
    id: item.id || item._id || item.code,
    sigla,
    code: item.code || item.codigo || item.numeroSolicitacao || "",
    numeroProposta: item.numeroProposta || item.numeroSolicitacao || item.codigo || item.code || "",
    numeroSolicitacao: item.numeroSolicitacao || item.codigo || item.code || "",
    cliente: clienteId,
    clienteCodigo:
      item.clienteCodigo ||
      item.cliente?.codigo ||
      item.cliente?.code ||
      item.customerCode ||
      item.clienteCode ||
      "",
    clienteNome: item.clienteNome || item.cliente?.nomeFantasia || item.credorNome || item.customerName || "",
    contato: contatoId,
    contatoComercial: contatoId,
    contatoNome: item.contatoComercialNome || item.contato?.nome || item.contatoComercial?.nome || "",
    contatoTelefone: item.contatoComercialTelefone || item.contato?.telefone || item.contatoComercial?.telefone || "",
    contatoComercialTelefone: item.contatoComercialTelefone || item.contato?.telefone || item.contatoComercial?.telefone || "",
    contatoComercialCelular: item.contatoComercialCelular || item.contato?.celular || item.contatoComercial?.celular || "",
    contatoComercialEmail: item.contatoComercialEmail || item.contato?.email || item.contatoComercial?.email || "",
    contatoTecnico: contatoTecnicoId,
    contatoTecnicoNome: item.contatoTecnicoNome || item.contatoTecnico?.nome || item.contatoTecnicoName || "",
    contatoTecnicoTelefone: item.contatoTecnicoTelefone || item.contatoTecnico?.telefone || "",
    contatoTecnicoCelular: item.contatoTecnicoCelular || item.contatoTecnico?.celular || "",
    contatoTecnicoEmail: item.contatoTecnicoEmail || item.contatoTecnico?.email || "",
    cliente_referencia: referenciaClienteValor,
    referenciaCliente: referenciaClienteValor,
    revisao: item.revisao || item.version || "",
    ultimaRevisao: item.ultimaRevisao || item.version || item.revisao || "",
    dateGenerate: item.dateGenerate || item.dataGeracao || "",
    dataCriacao: item.dataCriacao || item.createdAt || item.dateGenerate || item.dataSolicitacao || "",
    // Renomeado de "tipoDeOrcamento" para "tipoPropostaOrcamento": o SalesOrder já tem, no Schema
    // do backend, uma propriedade legada "tipoDeOrcamento" (enum travado em ["Comercial","Técnica"],
    // sem a opção "Comercial e Técnica") cuja validação quebra com qualquer valor fora desse enum
    // (erro "Entity not found by the provided entityId"). Para não colidir com ela, o campo usado
    // pela tela passou a ser "tipoPropostaOrcamento" (não declarado no Schema, portanto livre de enum).
    tipoFaturamento: item.tipoFaturamento || item.tipoPropostaOrcamento || null,
    tipoPropostaOrcamento: item.tipoPropostaOrcamento || item.tipoFaturamento || null,
    tipoOrcamentoVenda: item.tipoOrcamentoVenda || null,
    nivel: nivelNormalizado,
    contatoEmail: item.contatoComercialEmail || item.contatoComercial?.email || "",
    dataSolicitacao:
      item.dataSolicitacao ||
      item.createdAt ||
      item.dataCadastro ||
      item.dataEmissao ||
      "",
    dataDesejada: item.dataDesejada || item._mirror_dataDesejada || item.dataDespacho || "",
    status: statusId || item.status || null,
    statusDescription,
    valorEstimado:
      Number(
        item.valorEstimado ??
        item._mirror_valor_sIPI_cICMS ??
        item.valor ??
        item.total ??
        0
      ) || 0,
    valorDisponivel,
    ki,
    kidoCusto,
    porcentagemPIS: item.porcentagemPIS ?? "0",
    porcentagemCOFINS: item.porcentagemCOFINS ?? "0",
    porcentagemISS: item.porcentagemISS ?? item.porcentagemIIS ?? "0",
    porcentagemIIS: item.porcentagemIIS ?? "0",
    porcentagemICMSVenda,
    pocentagemIPIVenda: item.pocentagemIPIVenda ?? item.porcentagemIPI ?? "0",
    porcentagemIPI: item.porcentagemIPI ?? "0",
    precoVenda_sIPI_cICMS,
    precoVenda_cIPI_cICMS: item.precoVenda_cIPI_cICMS ?? (parseNumero(precoVenda_sIPI_cICMS) + parseNumero(item.valorIPI)),
    precoVenda_sIPI_sICMS,
    precoVenda_cISS: item.precoVenda_cISS ?? 0,
    kv,
    precoTotalLiquido: item.precoTotalLiquido ?? "0,00",
    baseCalculoICMS: item.baseCalculoICMS ?? "0,00",
    baseCalculoPIS: item.baseCalculoPIS ?? "0,00",
    valorPIS: item.valorPIS ?? "0,00",
    baseCalculoCOFINS: item.baseCalculoCOFINS ?? "0,00",
    valorCOFINS: item.valorCOFINS ?? "0,00",
    baseCalculoISS: item.baseCalculoISS ?? "0,00",
    valorISS: item.valorISS ?? "0,00",
    baseCalculoIRRF: item.baseCalculoIRRF ?? "0,00",
    valorIRRF: item.valorIRRF ?? "0,00",
    baseCalculoCSLL: item.baseCalculoCSLL ?? "0,00",
    valorCSLL: item.valorCSLL ?? "0,00",
    baseCalculoINSS: item.baseCalculoINSS ?? "0,00",
    valorINSS: item.valorINSS ?? "0,00",
    descricao: item.projetoDescricao || item.descricao || item._mirror_projeto || "",
    projetoDescricao: item.projetoDescricao || item.descricao || item._mirror_projeto || "",
    projeto: item.projetoDescricao || item.projeto || item._mirror_projeto || "",
    observacao: item.observacao || item.observacoes || "",
    dataDespacho: item.dataDespacho || item.dataDesejada || item._mirror_dataDesejada || "",
    dataConclusao: item.dataConclusao || "",
    // datas do bloco Comercial (mesmo padrão de hidratação/mirror do bloco Técnico)
    dataSolicitacaoComercial: item.dataSolicitacaoComercial || item._mirror_dataSolicitacaoComercial || "",
    dataDesejadaComercial: item.dataDesejadaComercial || item._mirror_dataDesejadaComercial || "",
    dataConclusaoComercial: item.dataConclusaoComercial || item._mirror_dataConclusaoComercial || "",
    _mirror_tipoDeEquipamento: item._mirror_tipoDeEquipamento || "",
    _mirror_projeto: item._mirror_projeto || item.projetoDescricao || item.descricao || "",
    _mirror_dataSolicitacao: item._mirror_dataSolicitacao || item.dataSolicitacao || "",
    _mirror_dataDesejada: item._mirror_dataDesejada || item.dataDesejada || item.dataDespacho || "",
    _mirror_dataConclusao: item._mirror_dataConclusao || item.dataConclusao || "",
    _mirror_dataSolicitacaoComercial: item._mirror_dataSolicitacaoComercial || item.dataSolicitacaoComercial || "",
    _mirror_dataDesejadaComercial: item._mirror_dataDesejadaComercial || item.dataDesejadaComercial || "",
    _mirror_dataConclusaoComercial: item._mirror_dataConclusaoComercial || item.dataConclusaoComercial || "",
    tipoDeEquipamento:
      (typeof item.tipoDeEquipamento === "object" ? item.tipoDeEquipamento?.id : item.tipoDeEquipamento) || null,
    tipoDeEquipamentoSigla:
      item.tipoDeEquipamentoSigla ||
      item.tipoDeEquipamento?.sigla ||
      item.tipoDeEquipamento?.codigo ||
      item.tipoDeEquipamento?.code ||
      "",
    tipoDeEquipamentoDescricao:
      item.tipoDeEquipamentoDescricao ||
      item.tipoDeEquipamento?.descricao ||
      item.tipoDeEquipamento?.nome ||
      item.tipoDeEquipamento?.description ||
      "",
    itens: Array.isArray(item.itens) ? item.itens : (Array.isArray(item.Itens) ? item.Itens : [])
  };
};

export const normalizaListaSalesOrder = (response, statusDescricaoPorId = {}) => {
  const lista =
    response?.data?.data?.data ||
    response?.data?.data ||
    response?.data ||
    [];

  if (!Array.isArray(lista)) return [];
  return lista.map((item) => normalizaItemSalesOrder(item, statusDescricaoPorId));
};

export const gerarPayloadPersistencia = (formulario = {}) => {
  const referenciaClienteValor = String(formulario.cliente_referencia ?? formulario.referenciaCliente ?? "").trim();
  const projetoDescricao = formulario.projetoDescricao || formulario.descricao || formulario.projeto || "";
  const dataDesejada = formulario.dataDesejada || formulario.dataDespacho || "";
  // Ver nota em normalizaItemSalesOrder: renomeado de "tipoDeOrcamento" para evitar colisão com o
  // campo legado homônimo do Schema (enum travado, quebra a validação do backend).
  const tipoPropostaOrcamento = formulario.tipoPropostaOrcamento || formulario.tipoFaturamento || null;
  const dateGenerateUTC = formulario.dateGenerate
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dateGenerate })
    : UtilDateTime.todayUTC();
  const dataCriacaoUTC = formulario.dataCriacao
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataCriacao })
    : UtilDateTime.todayUTC();
  const dataSolicitacaoUTC = formulario.dataSolicitacao
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataSolicitacao })
    : UtilDateTime.todayUTC();
  const dataDesejadaUTC = dataDesejada
    ? UtilDateTime.toFormatUTC({ dateTime: dataDesejada })
    : "";
  const dataConclusaoUTC = formulario.dataConclusao
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataConclusao })
    : "";
  const dataSolicitacaoComercialUTC = formulario.dataSolicitacaoComercial
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataSolicitacaoComercial })
    : UtilDateTime.todayUTC();
  const dataDesejadaComercialUTC = formulario.dataDesejadaComercial
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataDesejadaComercial })
    : "";
  const dataConclusaoComercialUTC = formulario.dataConclusaoComercial
    ? UtilDateTime.toFormatUTC({ dateTime: formulario.dataConclusaoComercial })
    : "";

  return {
    ...formulario,
    // Garante persistência correta dos campos ao gravar/editar/concluir, sem duplicar chaves
    origem: formulario.origem || "DELTA DUCON",
    cliente_referencia: referenciaClienteValor,
    referenciaCliente: referenciaClienteValor,
    contatoComercial: formulario.contato || formulario.contatoComercial || null,
    contatoTecnico: formulario.contatoTecnico || null,
    contatoComercialTelefone: formulario.contatoComercialTelefone || formulario.telefone || "",
    contatoComercialCelular: formulario.contatoComercialCelular || "",
    contatoComercialEmail: formulario.contatoComercialEmail || formulario.email || "",
    contatoTecnicoNome: formulario.contatoTecnicoNome || "",
    contatoTecnicoTelefone: formulario.contatoTecnicoTelefone || "",
    contatoTecnicoCelular: formulario.contatoTecnicoCelular || "",
    contatoTecnicoEmail: formulario.contatoTecnicoEmail || "",
    valorEstimado: Number(formulario.valorEstimado || 0),
    valorDisponivel: parseNumero(formulario.valorDisponivel),
    ki: parseNumero(formulario.ki),
    kidoCusto: parseNumero(formulario.kidoCusto),
    porcentagemPIS: parseNumero(formulario.porcentagemPIS),
    porcentagemCOFINS: parseNumero(formulario.porcentagemCOFINS),
    porcentagemISS: parseNumero(formulario.porcentagemISS || formulario.porcentagemIIS),
    porcentagemIIS: parseNumero(formulario.porcentagemIIS),
    porcentagemICMSVenda: parseNumero(formulario.porcentagemICMSVenda),
    pocentagemIPIVenda: parseNumero(formulario.pocentagemIPIVenda || formulario.porcentagemIPI),
    porcentagemIPI: parseNumero(formulario.porcentagemIPI),
    precoVenda_sIPI_cICMS: parseNumero(formulario.precoVenda_sIPI_cICMS),
    precoVenda_cIPI_cICMS: parseNumero(formulario.precoVenda_cIPI_cICMS),
    precoVenda_sIPI_sICMS: parseNumero(formulario.precoVenda_sIPI_sICMS),
    precoVenda_cISS: parseNumero(formulario.precoVenda_cISS),
    kv: parseNumero(formulario.kv),
    valorICMS: parseNumero(formulario.valorICMS),
    valorIPI: parseNumero(formulario.valorIPI),
    tipoPropostaOrcamento,
    tipoFaturamento: tipoPropostaOrcamento,
    tipoOrcamentoVenda: formulario.tipoOrcamentoVenda || null,
    nivel: formulario.nivel === null || formulario.nivel === undefined || formulario.nivel === ""
      ? ""
      : String(formulario.nivel),
    precoTotalLiquido: parseNumero(formulario.precoTotalLiquido),
    baseCalculoICMS: parseNumero(formulario.baseCalculoICMS),
    baseCalculoPIS: parseNumero(formulario.baseCalculoPIS),
    valorPIS: parseNumero(formulario.valorPIS),
    baseCalculoCOFINS: parseNumero(formulario.baseCalculoCOFINS),
    valorCOFINS: parseNumero(formulario.valorCOFINS),
    baseCalculoISS: parseNumero(formulario.baseCalculoISS),
    valorISS: parseNumero(formulario.valorISS),
    baseCalculoIRRF: parseNumero(formulario.baseCalculoIRRF),
    valorIRRF: parseNumero(formulario.valorIRRF),
    baseCalculoCSLL: parseNumero(formulario.baseCalculoCSLL),
    valorCSLL: parseNumero(formulario.valorCSLL),
    baseCalculoINSS: parseNumero(formulario.baseCalculoINSS),
    valorINSS: parseNumero(formulario.valorINSS),
    descricao: projetoDescricao,
    projetoDescricao,
    projeto: projetoDescricao,
    // WORKAROUND (ver comentário acima de codificarExtrasSalesOrderEmObservacao): embute
    // tipoPropostaOrcamento e as datas do bloco Comercial (formato yyyy-mm-dd, igual ao dos campos de
    // data da tela) dentro do texto de observacao, já que essas propriedades ainda não persistem de
    // verdade no backend. Usa os valores "crus" do formulário (não os já convertidos para UTC acima)
    // para não misturar formatos.
    observacao: codificarExtrasSalesOrderEmObservacao(
      String(formulario.observacao ?? formulario.observacoes ?? ""),
      {
        tipoPropostaOrcamento,
        dataSolicitacaoComercial: formulario.dataSolicitacaoComercial || "",
        dataDesejadaComercial: formulario.dataDesejadaComercial || "",
        dataConclusaoComercial: formulario.dataConclusaoComercial || ""
      }
    ),
    dateGenerate: dateGenerateUTC,
    dataCriacao: dataCriacaoUTC,
    dataSolicitacao: dataSolicitacaoUTC,
    dataDesejada: dataDesejadaUTC,
    dataDespacho: dataDesejadaUTC,
    dataConclusao: dataConclusaoUTC,
    dataSolicitacaoComercial: dataSolicitacaoComercialUTC,
    dataDesejadaComercial: dataDesejadaComercialUTC,
    dataConclusaoComercial: dataConclusaoComercialUTC,
    _mirror_projeto: projetoDescricao,
    _mirror_dataSolicitacao: dataSolicitacaoUTC,
    _mirror_dataDesejada: dataDesejadaUTC,
    _mirror_dataConclusao: dataConclusaoUTC,
    _mirror_dataSolicitacaoComercial: dataSolicitacaoComercialUTC,
    _mirror_dataDesejadaComercial: dataDesejadaComercialUTC,
    _mirror_dataConclusaoComercial: dataConclusaoComercialUTC,
    _mirror_valor_sIPI_cICMS: parseNumero(formulario.precoVenda_sIPI_cICMS),
    tipoDeEquipamento: formulario.tipoDeEquipamento || null,
    tipoDeEquipamentoSigla: formulario.tipoDeEquipamentoSigla || "",
    tipoDeEquipamentoDescricao: formulario.tipoDeEquipamentoDescricao || "",
    itens: Array.isArray(formulario.itens) ? formulario.itens.map((item) => ({
      ...item,
      tipoDeEquipamento: item.tipoDeEquipamento || null,
      tipoDeEquipamentoDescricao: item.tipoDeEquipamentoDescricao || "",
      tipoDeServico: item.tipoDeServico || null,
      tipoDeServicoDescricao: item.tipoDeServicoDescricao || "",
      description: item.description || item.descricao || "",
      descricao: item.descricao || item.description || "",
      qty: parseNumero(item.qty ?? item.quantidade),
      quantidade: parseNumero(item.quantidade ?? item.qty),
      dtPrev: item.dtPrev || "",
      obs: item.obs || item.observacao || "",
      observacao: item.observacao || item.obs || "",
      valorDisponivel: parseNumero(item.valorDisponivel),
      valorDisponivelTotal: parseNumero(item.valorDisponivelTotal ?? calcularValorDisponivelTotalItem(item)),
      porcentagemPIS: parseNumero(item.porcentagemPIS),
      porcentagemCOFINS: parseNumero(item.porcentagemCOFINS),
      ki: parseNumero(item.ki),
      kidoCusto: parseNumero(item.kidoCusto),
      porcentagemISS: parseNumero(item.porcentagemISS || item.porcentagemIIS),
      porcentagemIIS: parseNumero(item.porcentagemIIS || item.porcentagemISS),
      porcentagemICMSVenda: parseNumero(item.porcentagemICMSVenda),
      pocentagemIPIVenda: parseNumero(item.pocentagemIPIVenda || item.porcentagemIPI),
      porcentagemIPI: parseNumero(item.porcentagemIPI || item.pocentagemIPIVenda),
      kv: parseNumero(item.kv),
      precoVenda_sIPI_cICMS: parseNumero(item.precoVenda_sIPI_cICMS),
      precoVenda_cIPI_cICMS: parseNumero(item.precoVenda_cIPI_cICMS),
      precoVenda_sIPI_sICMS: parseNumero(item.precoVenda_sIPI_sICMS),
      precoVenda_cISS: parseNumero(item.precoVenda_cISS),
      valorICMS: parseNumero(item.valorICMS),
      valorIPI: parseNumero(item.valorIPI),
      vlrTotal: parseNumero(item.vlrTotal || item.valorTotal || calcularValorTotalItem(item)),
      valorTotal: calcularValorTotalItem(item),
      precoTotalLiquido: parseNumero(item.precoTotalLiquido),
      porcentagemBaseCalculoICMS: parseNumero(item.porcentagemBaseCalculoICMS),
      baseCalculoICMS: parseNumero(item.baseCalculoICMS),
      porcentagemBaseCalculoISS: parseNumero(item.porcentagemBaseCalculoISS),
      baseCalculoISS: parseNumero(item.baseCalculoISS),
      valorISS: parseNumero(item.valorISS),
      porcentagemBaseCalculoIRRF: parseNumero(item.porcentagemBaseCalculoIRRF),
      baseCalculoIRRF: parseNumero(item.baseCalculoIRRF),
      porcentagemIRRF: parseNumero(item.porcentagemIRRF),
      valorIRRF: parseNumero(item.valorIRRF),
      porcentagemBaseCalculoPIS: parseNumero(item.porcentagemBaseCalculoPIS),
      baseCalculoPIS: parseNumero(item.baseCalculoPIS),
      valorPIS: parseNumero(item.valorPIS),
      porcentagemBaseCalculoCOFINS: parseNumero(item.porcentagemBaseCalculoCOFINS),
      baseCalculoCOFINS: parseNumero(item.baseCalculoCOFINS),
      valorCOFINS: parseNumero(item.valorCOFINS),
      porcentagemBaseCalculoCSLL: parseNumero(item.porcentagemBaseCalculoCSLL),
      baseCalculoCSLL: parseNumero(item.baseCalculoCSLL),
      porcentagemCSLL: parseNumero(item.porcentagemCSLL),
      valorCSLL: parseNumero(item.valorCSLL),
      porcentagemBaseCalculoINSS: parseNumero(item.porcentagemBaseCalculoINSS),
      baseCalculoINSS: parseNumero(item.baseCalculoINSS),
      porcentagemINSS: parseNumero(item.porcentagemINSS),
      valorINSS: parseNumero(item.valorINSS),
      _mirror_valor_sIPI_cICMS: parseNumero(item._mirror_valor_sIPI_cICMS || 0)
    })) : []
  };
};